import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';

import Tag from '../Tag';

import PlusIcon from '../icons/PlusIcon';
import { isMobileScreen } from '../utils/breakpoints';

import { Modal, ModalHeader, ModalBody } from '../../';

import './PlusValuePropositionModal.scss';

const PlusValuePropositionModal = ({ isOpen, handleClose }) => {
  return (
    <Modal
      className="plus-value-proposition-modal"
      ariaHideApp={false}
      contentLabel="modal"
      isOpen={isOpen}
      onRequestClose={handleClose}
      size={isMobileScreen() ? 'fullscreen' : 'medium'}
    >
      <ModalHeader
        className="plus-value-proposition-modal__header"
        dataTest="payment-info-close"
        label={
          <Tag
            label="Spotahome PLUS"
            colorSchema="blue"
            size="small"
            keepLabelCase
            renderLeadingIcon={() => (
              <PlusIcon
                size="normal"
                className="plus-value-proposition__tag-icon"
              />
            )}
          />
        }
        onRequestClose={handleClose}
      />
      <ModalBody className="plus-value-proposition-modal__body">
        <h2 className="plus-value-proposition-modal__body-title">
          <strong>{trans('plus.value.proposition.modal.title')}</strong>
        </h2>
        <ul>
          <li
            dangerouslySetInnerHTML={{
              __html: trans('plus.value.proposition.modal.point1')
            }}
          />
          <li
            dangerouslySetInnerHTML={{
              __html: trans('plus.value.proposition.modal.point2')
            }}
          />
        </ul>
      </ModalBody>
    </Modal>
  );
};

PlusValuePropositionModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired
};

export default PlusValuePropositionModal;
